import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import CoreFolder from "../../../../../app/core/components/CoreFolder/CoreFolder";
import FolderSpecialRoundedIcon from "@mui/icons-material/FolderSpecialRounded";
import CoreSpinner from "../../../../../app/core/components/CoreSpinner/CoreSpinner";
import { Breadcrumbs, Typography, Link } from "@mui/material";
import FolderRoundedIcon from "@mui/icons-material/FolderRounded";
import { useSelector } from "react-redux";
import {
  useDoDeleteFolderMutation,
  useGetFoldersCustomQuery,
} from "../../../../api/admin/adminFolders";
import CoreDialog from "../../../../../app/core/components/CoreDialog/CoreDialog";
import { t } from "i18next";
import { toast } from "react-toastify";
import { FOLDER_NUMBER } from "../../../../../utils/constants/tables";
import CreateFolder from "./CreateFolder";
import CoreModal from "../../../../../app/core/components/CoreModal/CoreModal";

const FolderMacrocat = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const colorPrimary = useSelector((state) => state.app.primaryColor);

  const [selected, setSelected] = useState();
  const [foldersCustom, setFoldersCustom] = useState();
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [folder, setFolder] = useState();
  const [folderCustomDelete, setFolderCustomDelete] = useState();
  const [folderCustomEdit, setFolderCustomEdit] = useState();
  const [editModal, setEditModal] = useState(false);

  const [page, setPage] = useState({
    currentPage: 1,
    startRow: 0,
    endRow: FOLDER_NUMBER,
  });

  const { data: getFoldersCustom } = useGetFoldersCustomQuery(
    {
      page,
      userId: location?.state?.user?.id,
    },
    {
      skip: !location?.state?.user?.id,
    }
  );

  const [deleteFolder, { isLoading: loadingDelete }] =
    useDoDeleteFolderMutation();

  useEffect(() => {
    if (selected || folder) {
      navigate("documenti", {
        state: {
          catId: selected,
          user: {
            id: location?.state?.user?.id,
            name: location?.state?.user?.name,
          },
          folderId: folder,
        },
      });
    }
  }, [selected, navigate, location, folder]);

  useEffect(() => {
    if (getFoldersCustom) {
      setFoldersCustom(getFoldersCustom?.Data?.items);
    }
  }, [getFoldersCustom]);

  const handleGetExpensecat = (catId) => {
    setSelected(catId);
  };

  const handleGetExpenseFolder = (folId) => {
    setFolder(folId);
  };

  const confirmDeleteFolder = () => {
    deleteFolder(folderCustomDelete.id).then((res) => {
      if (res.data.Result === 1) {
        setOpenDeleteDialog(false);
        toast.success(t("DeleteFolder"));
      } else if (res.data.Exception) {
        toast.error(res.data.Exception);
      }
    });
  };

  const handleEditFolder = (el) => {
    setEditModal(true);
    setFolderCustomEdit(el);
  };

  const handleDeleteFolder = (folder) => {
    setFolderCustomDelete(folder);
    setOpenDeleteDialog(true);
  };

  const handleCloseDeleteDialog = () => {
    setOpenDeleteDialog(false);
  };

  if (!location) {
    return <CoreSpinner />;
  }

  return (
    <div>
      <div className=" w-full flex items-center space-x-20 ">
        <h2>{location?.state?.user?.name}</h2>
        <Breadcrumbs aria-label="breadcrumb">
          <Link
            underline="hover"
            color="inherit"
            className="cursor-pointer"
            onClick={() => navigate(-1)}
          >
            {t("Folders")}
          </Link>
          <Typography className="font-semibold " sx={{ color: colorPrimary }}>
            {t("MacroCategory")}
          </Typography>
        </Breadcrumbs>
      </div>
      <div className="flex flex-wrap pt-10">
        {location?.state?.data?.Data?.map((el) => (
          <div className="p-4">
            <CoreFolder
              icon={
                <FolderRoundedIcon
                  className="w-20 h-20"
                  style={{ color: colorPrimary }}
                />
              }
              onGetFolder={() => handleGetExpensecat(el.id)}
              nameFolder={el?.name || "N/A"}
            />
          </div>
        ))}

        {foldersCustom &&
          foldersCustom.map((el) => (
            <div className="p-4">
              <CoreFolder
                button={true}
                icon={
                  <FolderSpecialRoundedIcon
                    className="w-20 h-20"
                    style={{ color: colorPrimary }}
                  />
                }
                nameFolder={el?.name}
                onGetFolder={() => handleGetExpenseFolder(el.id)}
                onDelete={() => handleDeleteFolder(el)}
                onEdit={() => handleEditFolder(el)}
              />
            </div>
          ))}
      </div>
      <CoreDialog
        open={openDeleteDialog}
        title={t("Delete") + " " + t("Folder")}
        content={t("FolderDeletingConfirm") + ` "${folderCustomDelete?.name}"?`}
        positiveButton={t("Yes")}
        negativeButton={t("No")}
        handlePositive={confirmDeleteFolder}
        closeDialog={handleCloseDeleteDialog}
        disabledButton={loadingDelete}
      />
      <CoreModal
        width={"40%"}
        height={"40%"}
        onClose={() => setEditModal(false)}
        state={editModal}
        component={
          <CreateFolder
            onClose={() => setEditModal(false)}
            folder={folderCustomEdit}
          />
        }
      />
    </div>
  );
};

export default FolderMacrocat;
